export const VISIT_INTENT_ANALYZE = 'analyze';
export const VISIT_INTENT_SERVICE = 'service';

const PASSPORT_KIOSK_SOURCES = new Set([
  'passport_face',
  'passport_pending_registration',
  'guest_qr',
  'guest_qr_pending_registration',
]);

const STYLIST_LED_SOURCES = new Set(['stylist_mobile', 'stylist_led']);

export function normalizeVisitIntent(raw) {
  const v = String(raw || '').trim().toLowerCase();
  if (v === VISIT_INTENT_ANALYZE || v === 'analysis') return VISIT_INTENT_ANALYZE;
  if (v === VISIT_INTENT_SERVICE || v === 'services' || v === 'service') return VISIT_INTENT_SERVICE;
  return null;
}

export function readCheckinSnapshot(checkin) {
  return checkin?.customer_snapshot && typeof checkin.customer_snapshot === 'object'
    ? checkin.customer_snapshot
    : {};
}

export function readVisitIntentOrNull(checkin) {
  const snap = readCheckinSnapshot(checkin);
  return normalizeVisitIntent(snap.visit_intent || snap.visitIntent);
}

export function readVisitIntent(checkin) {
  return readVisitIntentOrNull(checkin) || VISIT_INTENT_SERVICE;
}

export function visitIntentLabel(intent) {
  const norm = normalizeVisitIntent(intent);
  if (!norm) return 'Not chosen yet';
  return norm === VISIT_INTENT_ANALYZE ? 'Skin & hair analysis' : 'Service list';
}

export function isPassportKioskCheckin(checkin) {
  const source = String(checkin?.source || '').trim().toLowerCase();
  const snap = readCheckinSnapshot(checkin);
  const entry = String(snap.entry_source || '').trim().toLowerCase();
  return PASSPORT_KIOSK_SOURCES.has(source) || PASSPORT_KIOSK_SOURCES.has(entry);
}

export function isStylistLedCheckin(checkin) {
  const source = String(checkin?.source || '').trim().toLowerCase();
  const snap = readCheckinSnapshot(checkin);
  const entry = String(snap.entry_source || '').trim().toLowerCase();
  return STYLIST_LED_SOURCES.has(source) || STYLIST_LED_SOURCES.has(entry) || Boolean(snap.stylist_led);
}

/** Front desk or guest kiosk confirmed — stylist may take the visit. */
export function isSalonReadyForStylist(checkin) {
  if (isStylistLedCheckin(checkin)) return true;
  const snap = readCheckinSnapshot(checkin);
  if (snap.guest_confirmed_at || snap.guestConfirmedAt) return true;
  if (snap.passport_kiosk_acknowledged || snap.passportKioskAcknowledged) return true;
  if (snap.front_desk_confirmed_at || snap.frontDeskConfirmedAt) return true;
  if (String(checkin?.status || '').toLowerCase() === 'in_service') return true;
  return false;
}

/** @deprecated use isSalonReadyForStylist */
export function isGuestConfirmedCheckin(checkin) {
  return isSalonReadyForStylist(checkin);
}

export function salonReadyAt(checkin) {
  const snap = readCheckinSnapshot(checkin);
  const candidates = [
    snap.guest_confirmed_at,
    snap.guestConfirmedAt,
    snap.passport_kiosk_acknowledged_at,
    snap.passportKioskAcknowledgedAt,
    snap.front_desk_confirmed_at,
    snap.frontDeskConfirmedAt,
  ]
    .map((v) => String(v || '').trim())
    .filter(Boolean);
  if (!candidates.length) return '';
  return candidates.sort().slice(-1)[0];
}

export function guestConfirmedAt(checkin) {
  return salonReadyAt(checkin);
}
